'use client';

import React, { useEffect, useState } from 'react';
import Markdown from '@/components/atoms/markdown';
import Typography from '@/components/atoms/typography';
import useAccount from '@/lib/hooks/useAccount';
import EnquiryForm from './FormEnquiry';

const ContactUsPage = ({ contactUsData }: any) => {
  const title = contactUsData?.sections?.[0]?.section_with_heading_description?.title ?? '';
  const summary = contactUsData?.sections?.[0]?.section_with_heading_description?.description ?? '';
  const account = useAccount();


  return (
    <>
      <div className="lg:grid lg:grid-cols-2">
        <div
          className={`contact-us-left leading-15 m-6 flex flex-1 flex-col items-center justify-center bg-[#F7F7F7]  text-center lg:px-10`}
        >
          <div className={`flex justify-center `}>
            <div className="flex flex-col items-center px-[36px] py-[18px] lg:px-[90px]">
              {title && (
                <Typography
                  fontSize={24}
                  className="pb-3 text-32 font-medium text-black xl:pb-8 xl:text-34  2xl:text-48 relative"
                >
                  {title}
                </Typography>
              )}

              <Markdown className="text-20 font-normal text-[#4D4D4D] md:w-268 lg:w-344 xl:text-18 2xl:text-20 md:[&>*:nth-child(1)]:mr-8 md:[&>*:nth-child(1)]:inline lg:[&>*:nth-child(1)]:mr-8 lg:[&>*:nth-child(1)]:inline lg:[&>*:nth-child(2)]:inline ">
                {summary}
              </Markdown>
            </div>
          </div>
        </div>

        <div className="leading-15 flex flex-1 flex-col gap-4 px-4 py-12 lg:gap-4 lg:px-[7rem]">
          <Typography as="h1" className="text-32 !font-medium !leading-10 text-black xl:text-32 2xl:text-48">
            Send us a message
            {/* {translate('common.contact.header')} */}
          </Typography>
          {/* <p className="py-4 text-[20px] text-xl font-normal !leading-8">
            {translate('common.contact.signedin.description')}
          </p> */}
          <div className="leading-15 flex flex-1 flex-col gap-4"></div>
          <EnquiryForm account={account} />
        </div>
      </div>
    </>
  );
};

export default ContactUsPage;
